export default "__VITE_ASSET__CfIYzR35__"